import { Route, Routes } from "react-router-dom";
import { EditEntry } from './Edit';
export const EntriesRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/shop/:shopId" element={<EditEntry />} />
    </Routes>
  );
}
